<div class="row justify-content-center" [ngClass]="routeAnimationsElements">
  <div class="grid">
    <!--<h4>Nuevo</h4>
      <a [ngClass]="routeAnimationsElements" mat-raised-button class="actions-main" color="primary"
        routerLink="../nuevo-vinculo-laboral">
        Solicitar nuevo vínculo laboral
      </a>-->

    <ng-container *ngIf="rolesPendientesUsuario.length > 0">
      <h4>Pendientes:</h4>
      <div class="gap">
        <div *ngFor="let rol of rolesPendientesUsuario">
          <rpe-vinculo-laboral-seccion [formInput]=rol (formValueChanges)="formValueChanges($event)"
            (formStatusChanges)="formStatusChanges($event)"></rpe-vinculo-laboral-seccion>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="rolesPendientesEmpresa.length > 0">
      <h4>Pendientes por parte de la empresa:</h4>
      <div class="gap">
        <div *ngFor="let rol of rolesPendientesEmpresa">
          <rpe-vinculo-laboral-seccion [formInput]=rol (formValueChanges)="formValueChanges($event)"
            (formStatusChanges)="formStatusChanges($event)"></rpe-vinculo-laboral-seccion>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="rolesAprobados.length > 0">
      <h4>Aprobados:</h4>
      <div class="gap">
        <div *ngFor="let rol of rolesAprobados">
          <rpe-vinculo-laboral-seccion [formInput]=rol (formValueChanges)="formValueChanges($event)"
            (formStatusChanges)="formStatusChanges($event)"></rpe-vinculo-laboral-seccion>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="rolesEliminados.length > 0">
      <h4>Rechazados:</h4>
      <div class="gap">
        <div *ngFor="let rol of rolesEliminados">
          <rpe-vinculo-laboral-seccion [formInput]=rol></rpe-vinculo-laboral-seccion>
        </div>
      </div>
    </ng-container>
  </div>
</div>